import { StatusTag } from '../../../../../equity/web/atoms/status-tag'

export const OwnershipTag = (props: { name: string }) => (
  <div className="max-w-full">
    <StatusTag variant="ghost" color="primary">{`By ${props.name}`}</StatusTag>
  </div>
)
